"use client";

import { c as _c } from "react/compiler-runtime";
import { useRef, useState } from "react";
import { Button } from "@/components/ui/button";
import { Send } from "lucide-react";
interface ChatInputProps {
  onSend: (content: string) => void;
  onTyping: () => void;
  placeholder?: string;
}
export function ChatInput(t0) {
  const $ = _c(21);
  const {
    onSend,
    onTyping,
    placeholder
  } = t0;
  const [value, setValue] = useState("");
  const inputRef = useRef(null);
  let t1;
  if ($[0] !== onSend || $[1] !== value) {
    t1 = () => {
      const trimmed = value.trim();
      if (!trimmed) {
        return;
      }
      onSend(trimmed);
      setValue("");
      inputRef.current?.focus();
    };
    $[0] = onSend;
    $[1] = value;
    $[2] = t1;
  } else {
    t1 = $[2];
  }
  const handleSend = t1;
  let t2;
  if ($[3] !== onTyping) {
    t2 = e => {
      setValue(e.target.value);
      onTyping();
    };
    $[3] = onTyping;
    $[4] = t2;
  } else {
    t2 = $[4];
  }
  let t3;
  if ($[5] !== handleSend) {
    t3 = e_0 => e_0.key === "Enter" && handleSend();
    $[5] = handleSend;
    $[6] = t3;
  } else {
    t3 = $[6];
  }
  const t4 = placeholder ?? "Scrivi un messaggio...";
  let t5;
  if ($[7] !== t2 || $[8] !== t3 || $[9] !== t4 || $[10] !== value) {
    t5 = <input ref={inputRef} value={value} onChange={t2} onKeyDown={t3} placeholder={t4} className="flex-1 rounded-full border bg-background px-4 py-2 text-sm outline-none focus:border-accent" />;
    $[7] = t2;
    $[8] = t3;
    $[9] = t4;
    $[10] = value;
    $[11] = t5;
  } else {
    t5 = $[11];
  }
  let t6;
  if ($[12] !== value) {
    t6 = value.trim();
    $[12] = value;
    $[13] = t6;
  } else {
    t6 = $[13];
  }
  const t7 = !t6;
  let t8;
  if ($[14] === Symbol.for("react.memo_cache_sentinel")) {
    t8 = <Send className="h-4 w-4" />;
    $[14] = t8;
  } else {
    t8 = $[14];
  }
  let t9;
  if ($[15] !== handleSend || $[16] !== t7) {
    t9 = <Button size="icon" onClick={handleSend} disabled={t7} className="h-9 w-9 shrink-0 rounded-full bg-accent text-accent-foreground hover:bg-accent/90">{t8}</Button>;
    $[15] = handleSend;
    $[16] = t7;
    $[17] = t9;
  } else {
    t9 = $[17];
  }
  let t10;
  if ($[18] !== t5 || $[19] !== t9) {
    t10 = <div className="flex items-center gap-2 border-t p-3">{t5}{t9}</div>;
    $[18] = t5;
    $[19] = t9;
    $[20] = t10;
  } else {
    t10 = $[20];
  }
  return t10;
}